module.exports = global["FastClick"] = require("-!./jquery.fastclick.js");


//////////////////
// WEBPACK FOOTER
// ./Library/1.0/vendor/jquery.fastclick.js-exposed
// module id = 415
// module chunks = 44 45